export default {
  default_program_name: 'Rewards Club',
  message:
    'Iscriviti a <highlight>{{name}}</highlight> — guadagna {{reward}} ogni {{spend}} spesi e sblocca articoli gratuiti!',
  buttons: {
    join_now: 'Iscriviti ora',
  },
};
